// extracted by mini-css-extract-plugin
module.exports = {"footer":"_5AmlF","footer-link":"WmfYZ","stickySlide":"kV5fD"};